<template>
    <video
        :class="{ lazy: lazyload }"
        playsinline
        loop
        muted
        autoplay
        :poster="posterUrl"
        :width="width"
        :height="height"
    >
        <source :data-src="lazyload ? src : null" :src="!lazyload ? src : null" type="video/webm" />
    </video>
</template>

<script setup lang="ts">
withDefaults(
    defineProps<{
        src: string;
        posterUrl: string;
        lazyload?: boolean;
        width?: number | string;
        height?: number | string;
    }>(),
    {
        lazyload: true,
    }
);
</script>
